<template>
<validation-observer ref="VacationJobsForm" class="form">
    <form ref="form" class="form">
        <validation-provider
        name="Meslek"
        :rules="{ required: true }"
        v-slot="validationContext"
        >
        <b-row>
            <b-col sm="4"> <label for="stock_movement_type"> {{$t('defination.vacation.job.jobs')}} </label> </b-col>
            <b-col sm="8"> 
                <Multiselect  
                    v-model="selectedJobs"
                    :show-labels="false" 
                    :options="showedJobs"
                    label="name"
                    track-by="id"
                    :multiple="true"
                    :state="getValidationState(validationContext)"
                    aria-describedby="live-feedback"
                    :placeholder="$t('general.select')"
                    >
                        <template slot="singleLabel" slot-scope="{ option }">
                            <strong>{{ option.text }} </strong> 
                        </template>
                </Multiselect>
                <b-form-invalid-feedback id="live-feedback">{{
                    validationContext.errors[0]
                }}</b-form-invalid-feedback>
            </b-col>
        </b-row>
        </validation-provider>
    </form>
</validation-observer>
</template>

<script>
    import Multiselect from 'vue-multiselect';
    export default {
        name: "VacationJobsForm",
        data(){
            return {
                vacationId: this.$route.params.id,
                selectedJobs: null,
                selectedJobsIdList: [],
                showedJobs: [],
                errMsg: ""
            }
        },
        async created(){
            await this.$store.dispatch("listJobs")
            // multiselect'te gösterilecek olan mesleklerin listelenmesi
            if (!this.data.list) {
                this.showedJobs = this.jobs
            } else {
                this.showedJobs = this.jobs.filter(job=>!this.data.list.map(listJob=>listJob.id).includes(job.id))
            }
        },
        props: {
            data: Object,
            changeData: Function,
            save: Boolean,
            saveState: Function,
            modalName: String,
            modalEvent: Function
        },
        components: {
            Multiselect
        },
        methods: {
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            clearForm() {
                this.errMsg = "";
                this.name = "",
                this.modalEvent(false);
            }
        },
        computed: {
            jobs(){
                return this.$store.getters.getJobs
            },
        },
        watch: {
            selectedJobs(val){
                this.selectedJobsIdList = val.map(job=>job.id)
            },
            save: async function(data) {
                if (data) {
                    this.$refs.VacationJobsForm.validate().then(async success => {
                    if (success){
                    let val = {
                        vacationId: this.vacationId,
                        jobs: {
                          alr_jobs: this.selectedJobsIdList
                        }
                    }
                    switch (this.modalName) {
                    case "add":
                        await this.$store.dispatch("addVacationJobs", val);
                        break;
                    case "edit":
                        /* bunun düzenleme kısmı yok */
                    }
                    if (this.$store.getters.getAddressStatus.status == "Success") {
                    this.$store.dispatch("listVacationJobs", {vacationId: this.vacationId});
                    this.clearForm();
                    } else {
                    this.errMsg = i18n.t("general.addErrMsg");
                    }
                    }
                    })
                    this.saveState(false);
                }
            }
        }
    }
</script>

<style lang="css" scoped > 
    @import "../styles/modalForm.min.css"; 
    @import "../styles/modal.min.css";
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/VacationsJobsForm.vue